"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { zodResolver } from "@hookform/resolvers/zod";
import { Plus, Trash2 } from "lucide-react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "sonner";
import type { z } from "zod/v4";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Form } from "@/components/ui/form";
import { FormInput } from "@/components/ui/input";
import { FormSelect } from "@/components/ui/select";
import { TOUR_TARGETS } from "@/features/onboarding-tours/orchestrator/tour-target-ids";
import { defaultPermissionsByRole } from "@/lib/constants/workspace-permission-resources";
import { completeTeamMemberSchema, multipleCompleteTeamMemberSchema, teamMemberSchema } from "@/lib/schema/team";
import { cn, getInitials, getUserRoleText } from "@/lib/utils";
import type { PermissionItem } from "@/types/permissions";
import { type InvitedUser, UserRole } from "@/types/user";
import { PermissionsSection } from "./permissions-section";
interface InviteUsersProps {
  onUsersChange: (users: InvitedUser[]) => void;
  className?: string;
}
type InviteUserFormValues = z.infer<typeof teamMemberSchema>;

// Convert permissions to PermissionItem[] for PermissionsSection
const getPermissionItems = (permissions: Record<string, {
  view?: boolean;
  create?: boolean;
  edit?: boolean;
  delete?: boolean;
}>): PermissionItem[] => {
  return Object.entries(permissions).map(([resource, actions]) => ({
    canCreate: actions.create || false,
    canDelete: actions.delete || false,
    canEdit: actions.edit || false,
    canView: actions.view || false,
    id: `temp-${resource}`,
    resource
  }));
};
const INITIAL_FORM_STATE = {
  email: "",
  role: UserRole.USER
};
export function InviteUsers(t0) {
  const $ = _c(39);
  const {
    onUsersChange,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [invitedUsers, setInvitedUsers] = useState(t2);
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      defaultValues: INITIAL_FORM_STATE,
      resolver: zodResolver(teamMemberSchema)
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const form = useForm(t3);
  let t4;
  if ($[2] !== form || $[3] !== invitedUsers || $[4] !== onUsersChange) {
    t4 = t5 => {
      const {
        email,
        role
      } = t5;
      if (invitedUsers.some(user => user.email === email)) {
        form.setError("email", {
          message: "This email has already been added"
        });
        return;
      }
      const defaultPermissions = defaultPermissionsByRole[role];
      const permissions = {};
      for (const [resource, actions] of Object.entries(defaultPermissions)) {
        permissions[resource] = {
          create: actions.create,
          delete: actions.delete,
          edit: actions.edit,
          view: actions.view
        };
      }
      const newUser = {
        email,
        id: `temp-${Date.now()}`,
        permissions,
        role
      };
      const validated = completeTeamMemberSchema.safeParse(newUser);
      if (!validated.success) {
        return form.setError("email", {
          message: validated.error.flatten().formErrors.join(", ")
        });
      }
      const updatedUsers = [...invitedUsers, newUser];
      setInvitedUsers(updatedUsers);
      onUsersChange(updatedUsers);
      form.reset(INITIAL_FORM_STATE);
    };
    $[2] = form;
    $[3] = invitedUsers;
    $[4] = onUsersChange;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleAddUser = t4;
  let t5;
  if ($[6] !== invitedUsers || $[7] !== onUsersChange) {
    t5 = userId => {
      const updatedUsers_0 = invitedUsers.filter(user_0 => user_0.id !== userId);
      setInvitedUsers(updatedUsers_0);
      onUsersChange(updatedUsers_0);
    };
    $[6] = invitedUsers;
    $[7] = onUsersChange;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const handleRemoveUser = t5;
  let t6;
  if ($[9] !== invitedUsers || $[10] !== onUsersChange) {
    t6 = (userId_0, _index, updatedPermission) => {
      const updatedUsers_1 = invitedUsers.map(user_1 => {
        if (user_1.id === userId_0) {
          const newPermissions = {
            ...user_1.permissions
          };
          newPermissions[updatedPermission.resource] = {
            create: updatedPermission.canCreate,
            delete: updatedPermission.canDelete,
            edit: updatedPermission.canEdit,
            view: updatedPermission.canView
          };
          return {
            ...user_1,
            permissions: newPermissions
          };
        }
        return user_1;
      });
      const validated_0 = multipleCompleteTeamMemberSchema.safeParse(updatedUsers_1);
      if (!validated_0.success) {
        return toast.error(validated_0.error.flatten().formErrors.join(", "));
      }
      setInvitedUsers(updatedUsers_1);
      onUsersChange(updatedUsers_1);
    };
    $[9] = invitedUsers;
    $[10] = onUsersChange;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const handlePermissionChange = t6;
  let t7;
  if ($[12] !== className) {
    t7 = cn("space-y-8 sm:space-y-5", className);
    $[12] = className;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== form || $[15] !== handleAddUser) {
    t8 = form.handleSubmit(handleAddUser);
    $[14] = form;
    $[15] = handleAddUser;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== form) {
    t9 = <FormInput className="[&_input]:h-9" form={form} id={TOUR_TARGETS.inviteEmailField} name="email" placeholder="Enter email address" type="email" wrapperClassName="flex-1 min-w-0" />;
    $[17] = form;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = Object.values(UserRole).map(_temp);
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== form) {
    t11 = <FormSelect className="w-[120px] shrink-0 [&_button]:h-9! [&_button]:w-full!" form={form} name="role" options={t10} placeholder="Select role" />;
    $[20] = form;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Button className="h-9 w-9 shrink-0" size="icon" type="submit" variant="default"><Plus /></Button>;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t11 || $[24] !== t8 || $[25] !== t9) {
    t13 = <form className="flex items-start gap-2 w-full" id={TOUR_TARGETS.inviteEmailSection} onSubmit={t8}>{t9}{t11}{t12}</form>;
    $[23] = t11;
    $[24] = t8;
    $[25] = t9;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== form || $[28] !== t13) {
    t14 = <Form {...form}>{t13}</Form>;
    $[27] = form;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== form.formState || $[31] !== handlePermissionChange || $[32] !== handleRemoveUser || $[33] !== invitedUsers) {
    t15 = !!invitedUsers.length && <div className="space-y-4">{invitedUsers.map(user_2 => <div className="rounded-lg border p-4 pt-5 pb-0 relative space-y-3" key={user_2.id}><Badge className={cn("capitalize text-[10px] px-1.5 py-0.25 absolute -top-2 left-2")} variant={user_2.role === UserRole.ADMIN ? "default" : "secondary"}>{getUserRoleText(user_2.role)}</Badge><div className="flex items-center gap-2"><Avatar><AvatarFallback className="bg-gray-100">{getInitials(user_2.email).toUpperCase()}</AvatarFallback></Avatar><div className="flex-1 min-w-0"><p className="font-medium leading-tight truncate">{user_2.email}</p></div><Button className="size-5 p-0 text-destructive/60 hover:text-destructive hover:bg-transparent shrink-0 ml-auto" disabled={form.formState.isSubmitting} onClick={() => handleRemoveUser(user_2.id)} size="icon" variant="ghost"><Trash2 className="size-4" /></Button></div><PermissionsSection id={TOUR_TARGETS.invitePermissionsSection} onPermissionChange={(index, updatedPermission_0) => handlePermissionChange(user_2.id, index, updatedPermission_0)} permissions={getPermissionItems(user_2.permissions)} /></div>)}</div>;
    $[30] = form.formState;
    $[31] = handlePermissionChange;
    $[32] = handleRemoveUser;
    $[33] = invitedUsers;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t14 || $[36] !== t15 || $[37] !== t7) {
    t16 = <div className={t7}>{t14}{t15}</div>;
    $[35] = t14;
    $[36] = t15;
    $[37] = t7;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  return t16;
}
function _temp(role_0) {
  return {
    label: getUserRoleText(role_0),
    value: role_0
  };
}